import React from 'react'
import { Icon } from 'semantic-ui-react'

import moment from 'moment'

const VocationalExperience = ({
  isViewAsTeacher,
  expType,
  experiences,
  showEditExp,
  setQTarget,
  setQType,
  toogleShowConfirmModal,
}) => {
  return experiences && experiences.length > 0 ? (
    <ul className='container p-0'>
      {experiences
        .sort((a, b) => {
          let dateA = moment(a.end_date, 'MM/YYYY')
          let dateB = moment(b.end_date, 'MM/YYYY')
          return dateB.diff(dateA)
        })
        .map((q, index, array) => {
          return (
            <li key={q._id} className='p-0'>
              <div className='row'>
                <div className='col-8'>
                  {/* <p className="mt-0 mb-0 profile-qualification-title text-left">{q.graduation_date}</p> */}
                  <p className='mt-0 mb-2 profile-qualification-title text-left'>
                    {q.organisation}
                  </p>
                  <p className='mt-0 mb-2 profile-qualification-place text-left'>
                    {q.institution_city ? `${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                  </p>
                  <p className='profile-qualification-place text-left'>
                    {q.course_class_delivered.length > 0
                      ? q.course_class_delivered
                        .map((item) => item.label)
                        .join(' | ')
                      : q.course_class_delivered}
                    {q.role_held}
                  </p>
                </div>
                <div className='col-4'>
                  <p className='mt-0 mb-0 profile-qualification-title text-right'>
                    {/* {q.end_date.length === 7 && q.start_date.length === 7 ?  */}
                    {
                      moment(q.start_date, 'MM/YYYY').format('MMM YYYY') +
                      ' - ' +
                      (q.end_date !== 'Present'
                        ? moment(q.end_date, 'MM/YYYY').format('MMM YYYY')
                        : q.end_date)
                    }
                    {/* : 'NaN'} */}
                  </p>

                  {isViewAsTeacher ? (
                    <p className='mb-0 profile-qualification-title text-right mt-2'>
                      <Icon
                        name='pencil'
                        circular
                        inverted
                        color='#3bb4d8'
                        onClick={() => showEditExp(q)}
                        className='qualification-container-update-icon'
                      >
                        {' '}
                      </Icon>
                      <Icon
                        name='trash'
                        circular
                        inverted
                        color='grey'
                        onClick={() => {
                          setQTarget(q)
                          setQType(expType)
                          toogleShowConfirmModal(true)
                        }}
                        className='qualification-container-update-icon'
                      >
                        {' '}
                      </Icon>
                    </p>
                  ) : null}
                </div>
                {index !== array.length - 1 && (
                  <div className='col-12'>
                    <hr className='qualification-line-1 my-3'></hr>
                  </div>
                )}
              </div>
            </li>
          )
        })}
    </ul>
  ) : null
}

export default VocationalExperience
